// The trial price a new student would pay after the welcome coupon, for the
// offer strips. Mirrors StudentReferrals::ApplyDiscountService:
// the coupon caps at the order amount, so the price stops at zero.
//
// Returns null when there is no paid trial to talk about: no trial package, a
// free trial, a coupon in another currency, or no positive coupon. Callers then
// name only the coupon amount.
export function welcomeCouponTrialPrice({ couponAmount, couponCurrency, trialPackage }) {
  const coupon = Number(couponAmount)
  const original = Number(trialPackage?.totalPrice)
  if (!trialPackage || !(coupon > 0) || !(original > 0)) return null
  if ((trialPackage.currency || 'TWD') !== (couponCurrency || 'TWD')) return null

  return { original, final: Math.max(0, original - coupon), currency: trialPackage.currency || 'TWD' }
}

// The same price for a page's welcome coupon offer (`{ offer, amount, currency }`
// from useWelcomeCouponOffer), or null when there is no offer to claim or just
// claimed. Only the offer strips name it; package cards wait for the server
// preview, because an unclaimed coupon does not apply at checkout.
export function offerTrialPrice(welcomeCoupon, trialPackage) {
  if (!['claimable', 'claimed'].includes(welcomeCoupon?.offer?.status)) return null
  return welcomeCouponTrialPrice({ couponAmount: welcomeCoupon.amount, couponCurrency: welcomeCoupon.currency, trialPackage })
}

// The trial price an offer strip names: the price after the coupon, or null
// when the trial also has a referral discount (see trialHasOtherDiscount) or
// there is no offer. Both strips call this so desktop and mobile agree.
export function stripTrialPrice(welcomeCoupon, trialPackage, trialPreview) {
  return trialHasOtherDiscount(trialPreview) ? null : offerTrialPrice(welcomeCoupon, trialPackage)
}

// True when the server preview gives the trial a discount that is not the
// welcome coupon (a referral balance). Checkout stacks the two, so a strip must
// then name only the coupon, not a trial price checkout won't charge.
export function trialHasOtherDiscount(preview) {
  return preview?.applied > 0 && !(preview?.welcome_applied > 0)
}
